// Shared reading-source label mapping for logbook readings (HTN, weight, BG).
// Maps a raw reading source (from the API) to an i18n key under `readingSource`.
// Multiple raw sources can collapse to the same label.
export const READING_SOURCE_LABEL_KEYS = {
    TELADOC_DEVICE: 'readingSource.teladocDevice',
    TELADOC_DEVICE_DERIVED: 'readingSource.teladocDevice',
    GOOGLE_HEALTH_KIT: 'readingSource.googleHealth',
    GOOGLE_HEALTH_CONNECT: 'readingSource.googleHealth',
    APPLE_HEALTH_CONNECT: 'readingSource.appleHealth',
    APPLE_HEALTH_KIT: 'readingSource.appleHealth',
    OTHER: 'readingSource.teladocApp',
};

// Returns the i18n key for a reading source, or null when the source is empty.
// Unknown sources fall back to the "Teladoc App" key.
export const getReadingSourceLabelKey = readingSource =>
    readingSource
        ? READING_SOURCE_LABEL_KEYS[readingSource.toUpperCase()] ||
          READING_SOURCE_LABEL_KEYS.OTHER
        : null;

// Resolves a reading source to its translated label using the provided `t`.
// Returns '' when the source is empty.
export const getReadingSourceLabel = (t, readingSource) => {
    const key = getReadingSourceLabelKey(readingSource);

    return key ? t(key) : '';
};
